import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function login(next = "/app") {
  const redirectUrl = window.location.origin + next;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function logout() {
  await api.post("/auth/logout").catch(() => {});
  window.location.href = "/";
}

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/session", { session_id: sid }, { withCredentials: true })
      .then(() => navigate(location.pathname.startsWith("/app") ? location.pathname : "/app", { replace: true }))
      .catch(() => navigate("/?signin=failed", { replace: true }));
  }, [location, navigate]);
  return null;
}
